import { Component, h, Prop, Event, EventEmitter, State, Listen } from '@stencil/core';
import { checkActivePath } from '@src/hylo-components/utils/usefull/usefull';
import { getMenuPageBySlug, getMenuPageByHref } from '@src/hylo-components/utils/hylo/hylo';


@Component({
  tag: 'kn-header',
})
export class KnHeader {

  constructor() {

    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleSubMenu = this.toggleSubMenu.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onUserMenu = this.onUserMenu.bind(this);
  }


  @Prop() menuData: string;

  @Event() knHeaderMenuClosed: EventEmitter;
  @Event() knHeaderMenuOpened: EventEmitter;


  @State() update: number = 0;
  @State() translations: any = {};
  @State() scroll_show: boolean = true;

  private me: HTMLElement;
  private menu: HTMLHyloPageMenuElement;
  private burger: HTMLHyloAccessibilityButtonElement;
  private search_1: HTMLInputElement;
  private search_2: HTMLInputElement;
  private backdrop: HTMLHyloBackdropElement;
  private scroll_position: number = 0;
  private logo_color: string;

  private user_button: HTMLHyloAccessibilityButtonElement;
  private user_menu: HTMLElement;
  private user_open: boolean = false;


  @Listen('knHeaderLogoColor', {target: 'window'})
  onKnHeaderLogoColor(event: CustomEvent) {

    if (!this.logo_color && !event.detail) return;

    if (!this.logo_color || !event.detail) {
      this.logo_color = event.detail;
      this.update++;
      return;
    }

    if (this.logo_color == event.detail) return;

    this.logo_color = event.detail;
    this.update++;
  }

  @Listen('hyloMenuUpdated')
  onHyloMenuUpdated() {

    this.update++;
  }

  @Listen('hyloMenuOpen')
  onHyloMenuOpen() {

    this.user_open = false;
    this.update++;
    this.knHeaderMenuOpened.emit();
  }

  @Listen('hyloMenuClose')
  onHyloMenuClose() {

    this.update++;
    this.knHeaderMenuClosed.emit();
  }

  @Listen('hyloFocusinAreas')
  onHyloFocusinAreas(event: CustomEvent) {

    const focused = event.detail as HTMLElement[];
    const sub = this.me.querySelectorAll('.kn-header-layer-sub');
    const user = this.me.querySelectorAll('.kn-header-layer-user');

    for (let i=0, l=sub.length; i<l; i++) {
      if (focused.includes(sub[i] as HTMLElement)) {
        sub[i].classList.add('hylo-open');
        (sub[i].previousElementSibling as HTMLHyloAccessibilityButtonElement).setStatus('on');
      } else {
        sub[i].classList.remove('hylo-open');
        (sub[i].previousElementSibling as HTMLHyloAccessibilityButtonElement).setStatus('off');
      }
    }

    for (let i=0, l=user.length; i<l; i++) {
      if (focused.includes(user[i] as HTMLElement)) {
        if (!this.user_open) {
          this.user_open = true;
          this.update++;
        }
      } else {
        if (this.user_open) {
          this.user_open = false;
          this.update++;
        }
      }
    }
  }

  @Listen('hyloFocusoutAreas')
  onHyloFocusoutAreas() {

    const sub = this.me.querySelectorAll('.kn-header-layer-sub');
    for (let i=0, l=sub.length; i<l; i++) {
      sub[i].classList.remove('hylo-open');
      (sub[i].previousElementSibling as HTMLHyloAccessibilityButtonElement).setStatus('off');
    }
    
    if (this.user_open) {
      this.user_open = false;
      this.update++;
    }
  }

  @Listen('hyloNavWillChange', {target: 'body'})
  onHyloNavWillChange() {

    if (this.user_open) {
      this.user_open = false;
      this.update++;
    }
  }

  @Listen('click', {target: 'body'})
  onClick(event: MouseEvent) {

    const target = event.target as HTMLElement;

    if (!this.user_menu?.contains(target) && this.user_button != target && !this.user_button?.contains(target)) {
      if (this.user_open) {
        this.user_open = false;
        this.update++;
      }
    }
  }

  @Listen('knDashboardClicked', {target: 'body'})
  onKnDashboardClicked() {
    
    if (this.user_open) {
      this.user_open = false;
      this.update++;
    }
  }

  @Listen('scroll', {target: 'window'})
  onScroll() {

    const position = window.scrollY;

    if (position - this.scroll_position > 10) {
      this.scroll_position = position;
      this.scroll_show = false;
    } else if (position - this.scroll_position < -10) {
      this.scroll_position = position;
      this.scroll_show = true;
    }
  }

  componentWillLoad() {

    const root = document.querySelector('hylo-page-root') as HTMLHyloPageRootElement;
    root.translationPromise.then(translations => this.translations = translations);

    this.scroll_position = window.scrollY;
  }

  componentDidLoad() {

    this.componentDidUpdate();
  }

  componentDidUpdate() {

    if (this.menu.open) {
      document.body.classList.add('backdrop-no-scroll');
      if (!this.backdrop) {
        this.backdrop = document.createElement('hylo-backdrop');
        document.body.append(this.backdrop);
      }
      this.scroll_position = window.scrollY;
      this.scroll_show = true;
    } else {
      if (this.backdrop) {
        this.backdrop.removeBackdrop();
        this.backdrop = null;
      }
      document.body.classList.remove('backdrop-no-scroll');
    }
  }


  private async toggleMenu() {

    const status = await this.burger.getStatus();
    this.menu.open = status == 'on';
  }

  private async toggleSubMenu(event: CustomEvent) {

    const target = event.target as HTMLHyloAccessibilityButtonElement;
    const status = await target.getStatus();

    const sub = this.me.querySelectorAll('.kn-header-layer-sub');
    for (let i=0, l=sub.length; i<l; i++) {
      if (status == 'off' || sub[i] != target.nextElementSibling) {
        sub[i].classList.remove('hylo-open');
        (sub[i].previousElementSibling as HTMLHyloAccessibilityButtonElement).setStatus('off');
      } else sub[i].classList.add('hylo-open');
    }
  }

  private getMenuMain(item: any, index: number) {

    item = getMenuPageByHref(item.href, this.menu?.menu?.main);
    if (!item) return null;

    const getMenuMainLevel = (item: any, level: number, label: string = '') => {

      let classes = checkActivePath(item.href) ? ['hylo-selected', 'tw-select-none'] : ['tw-select-none'];
      let link_classes = [];
      let container_classes = ['tw-w-fit tw-flex tw-flex-col tw-py-6 tw-px-4 md:tw-p-0 tw-mb-2 md:tw-mb-0 tw-rounded-hylo-default md:!tw-bg-transparent'];

      if (index == 0) container_classes.push('tw-bg-hylo-three-500');
      if (index == 1) container_classes.push('tw-bg-hylo-two-400');
      if (index == 2) container_classes.push('tw-bg-hylo-one-400');

      if (level == 0) {
        classes.push('tw-w-fit', 'tw-rounded-hylo-default', 'tw-px-2', 'tw-py-1', 'hylo-apple:tw-pt-2', 'hylo-apple:tw-pb-0', 'tw-mb-2', 'md:tw-mt-5');
        classes.push('!tw-bg-hylo-one-700', 'hylo-hover:!tw-bg-hylo-black', 'hylo-focus:!tw-bg-hylo-black', 'hylo-selected:!tw-bg-hylo-black');
        link_classes.push('!tw-text-[2rem]', '!tw-leading-[1.2]', '!tw-font-semibold', '!tw-tracking-[-0.32px]', 'tw-whitespace-nowrap');
        if (index == 0) link_classes.push('!tw-text-hylo-three-500 hylo-dark:!tw-text-hylo-three-400');
        if (index == 1) link_classes.push('!tw-text-hylo-two-400');
        if (index == 2) link_classes.push('!tw-text-hylo-one-400');
      }

      if (level >= 1) {
        link_classes.push('!tw-text-[1.25rem]', '!tw-leading-[1.6]', '!tw-tracking-[-0.2px]');
        link_classes.push('!tw-text-hylo-black', 'md:hylo-hover:!tw-text-hylo-one-600', 'md:hylo-focus:!tw-text-hylo-one-600', 'md:hylo-selected:!tw-text-hylo-one-600');
      }

      if (level == 1) {
        link_classes.push('!tw-font-semibold');
      }

      if (level == 2) {
        classes.push('md:tw-pl-4');
      }

      const button_classes = classes.concat(link_classes);
      link_classes.push(`hylo-accessibility-list-child`, '!tw-no-underline');

      label += `${item.name}, `;

      const main = [];
      const sub = [];

      let href = item.href;
      if (level == 0 && item.children[0]?.href) href = item.children[0].href;

      main.push(<hylo-router-link
        class={classes.join(' ') + (level == 0 ? ' !tw-hidden md:!tw-inline-flex' : '')}
        linkClass={link_classes.join(' ')}
        href={href}
        linkLabel={`${this.translations.labelSwitchToPage} ${label}, ${checkActivePath(item.href, true) ? this.translations.labelCurrentPage+',' : ''}`}
        no-outline
      >{item.name}</hylo-router-link>);

      if (level == 0) {
        main.push(
          <hylo-accessibility-button 
            class={button_classes.join(' ') + ' md:!tw-hidden'}
            toggle='closed'
            inactive 
            preventFocus
            onHyloAccessibilityButtonClicked={this.toggleSubMenu}
            aria-hidden="false"
          >{item.name}</hylo-accessibility-button>
        );
      }

      if (item.children) {
        for (let i=0, l=item.children.length; i<l; i++) {
          if (level == 0) sub.push(getMenuMainLevel(item.children[i], level+1, label));
          else main.push(getMenuMainLevel(item.children[i], level+1, label));
        }
      }

      if (level == 0) main.push(<div class="kn-header-layer-sub tw-max-h-0 tw-overflow-hidden hylo-open-direct:tw-max-h-250 md:!tw-max-h-none tw-transition-[max-height]">
        <div class={container_classes.join(' ')}>{sub}</div>
      </div>);

      return main;
    }

    return (
      <div class="tw-flex tw-flex-col">
        {getMenuMainLevel(item, 0)}
      </div>
    )
  }

  private getMenuSub(items: any[]) {

    const left = getMenuPageBySlug('left', items)?.children;
    const right = getMenuPageBySlug('right', items)?.children;

    let classes = ['tw-select-none'];
    let link_classes = [`hylo-accessibility-list-child`, '!tw-no-underline'];

    classes.push('tw-w-fit');
    link_classes.push('!tw-text-[2rem]', '!tw-leading-[1.375]', '!tw-tracking-[-0.32px]', '!tw-font-semibold');
    link_classes.push('!tw-text-hylo-black', 'hylo-hover:!tw-text-hylo-one-600', 'hylo-focus:!tw-text-hylo-one-600', 'hylo-selected:!tw-text-hylo-one-600');

    return (
      <div class="tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap lg:tw-flex-nowrap tw-gap-x-20 tw-gap-x-10 tw-justify-start lg:tw-justify-between tw-max-w-250">
        <div class="tw-flex tw-flex-col tw-w-full sm:tw-w-auto">
          {left?.map(item => {

            return (
              <hylo-router-link
                class={classes.join(' ') + (checkActivePath(item.href) ? ' hylo-selected' : '')}
                linkClass={link_classes.join(' ')}
                href={item.href}
                linkLabel={`${this.translations.labelSwitchToPage} ${item.name}, ${checkActivePath(item.href, true) ? this.translations.labelCurrentPage+',' : ''}`}
                no-outline
              >{item.name}</hylo-router-link>
            )
          })}
        </div>
        <div class="tw-flex tw-flex-col tw-w-full sm:tw-w-auto">
          {right?.map(item => {

            return (
              <hylo-router-link
                class={classes.join(' ') + (checkActivePath(item.href) ? ' hylo-selected' : '')}
                linkClass={link_classes.join(' ')}
                href={item.href}
                linkLabel={`${this.translations.labelSwitchToPage} ${item.name}, ${checkActivePath(item.href, true) ? this.translations.labelCurrentPage+',' : ''}`}
                no-outline
              >{item.name}</hylo-router-link>
            )
          })}
          {!this.menu?.menu?.user && <hylo-router-link
            class={classes.join(' ') + ' !tw-hidden md:!tw-inline-flex'}
            linkClass={link_classes.join(' ')}
            href={this.menu?.menu?.login.href}
            linkLabel={`${this.translations.labelSwitchToPage} ${this.menu?.menu?.login.name},`}
            no-outline
          >Login</hylo-router-link>}
          {!!this.menu?.menu?.user && <hylo-router-link
            class={classes.join(' ') + ' !tw-hidden md:!tw-inline-flex'}
            linkClass={link_classes.join(' ')}
            href={this.menu?.menu?.user.children.Logout.url}
            linkLabel={`${this.translations.labelSwitchToPage} Logout,`}
            no-outline
          >Logout</hylo-router-link>}
        </div>
        <div class="tw-hidden lg:tw-flex tw-justify-end tw-grow-[0.3]">
          <form
            class="tw-flex tw-max-w-72 tw-h-10 tw-gap-x-1 tw-bg-hylo-one-300 tw-rounded-hylo-default"
            onSubmit={this.onSearch}
          >
            <input 
              ref={el => this.search_1 = el}
              class="tw-max-w-60 tw-h-full tw-pl-3 tw-py-1.5 tw-bg-transparent tw-outline-0"
              aria-label={this.translations.labelSearchTerm+', '}
              />
            <hylo-button
              buttonClass='tw-flex !tw-px-3 tw-justify-center tw-items-center !tw-border-0'
              type="submit"
              buttonLabel={this.translations.labelStartSearch+', '}
            ><hylo-icon icon="search" width={24} /></hylo-button>
          </form>
        </div>
      </div>
    )
  }


  private onSearch(event: SubmitEvent) {

    event.preventDefault();
    event.stopPropagation();

    const search = (event.target as HTMLElement).querySelector('input');
    const value = search.value.trim();

    this.search_1.value = "";
    this.search_2.value = "";

    const router = document.querySelector('hylo-router');
    router.push(this.menu?.menu?.search?.href, {q: value});

    return false;
  }


  private async onUserMenu() {

    this.user_open = (await this.user_button.getStatus()) == 'on';
    this.menu.open = false;
    this.update++;
  }


  render() {

    let logo_color = '';
    if (this.logo_color) logo_color = this.logo_color;

    return (
      <header 
        ref={el => this.me = el}
        class={{'hylo-arbitrary': this.scroll_show, 'tw-h-0 tw-pointer-events-none': true}}
      >
        <hylo-page-menu 
          ref={el => this.menu = el}
          data={this.menuData}
          focusAreas='kn-header .kn-header-layer, kn-header .kn-header-layer-sub, kn-header .kn-header-layer-user'
        >

          <div class="tw-w-screen tw-relative tw-pointer-events-auto md:tw-pointer-events-none">
            <hylo-page-width class="tw-py-5 md:tw-pt-18 md:tw-pb-0 tw-bg-hylo-bg-body md:tw-bg-transparent !tw-fixed md:!tw-absolute tw-z-10">
              <hylo-router-link
                class="tw-pointer-events-auto tw-select-none"
                linkClass={`!tw-text-hylo-one-700 hylo-dark:!tw-text-white ${logo_color} tw-transition-colors`}
                href={!this.menu?.menu?.home ? 'javascript: void(0);' : this.menu.menu.home}
                linkLabel={`logo Kubinaut, ${this.translations.labelSwitchToPage} ${this.translations.textHomePage},`}
                noOutline
              ><hylo-icon icon="kubinaut-new" height="43" color="currentColor" /></hylo-router-link>
            </hylo-page-width>
          </div>

          <nav 
            class="tw-block tw-fixed tw-w-screen tw-top-0 tw-left-0 tw-z-50"
            aria-label={this.translations.labelMainMenu}
          >
            <hylo-accessibility-list type="menu">

              <div class="tw-hidden md:tw-block tw-w-full tw-bg-hylo-bg-body tw-h-13 tw-py-2 tw--mt-13 hylo-open:tw-mt-0 hylo-arbitrary:tw-mt-0 tw-transition-[margin] tw-relative tw-z-10 tw-pointer-events-auto">
                <hylo-page-width>
                  <div class="tw-flex tw-justify-between tw-items-center">
                    <div class="tw-flex tw-gap-2">
                      {this.menu?.menu?.social?.map(item => {

                        let width = "20";
                        if (item.id == 'instagram') width = "19";
                        if (item.id == 'news') width = "24";

                        return (
                          <hylo-router-link
                            class={`hylo-button hylo-action-primary hylo-fixed tw-select-none`}
                            linkClass='hylo-accessibility-list-child'
                            href={!item.href ? 'javascript: void(0);' : item.href}
                            linkLabel={`${this.translations.labelSwitchToPage} ${item.name}, ${item.id == 'news' ? '' : this.translations.labelOpensInNewBrowserTab},`}
                            noOutline
                          ><hylo-icon icon={item.id} height="20" width={width}/></hylo-router-link>
                        )
                      })}
                    </div>
                    {!!this.menu?.menu && <div class="tw-flex tw-items-center tw-gap-x-3 tw-select-none">
                      {!!this.menu.menu.easy_speach && 
                      <hylo-router-link
                        href={this.menu.menu.easy_speach.href}
                        class="hylo-button hylo-plain"
                        linkClass='hylo-accessibility-list-child !tw-text-hylo-black hylo-hover:!tw-text-hylo-one-600 hylo-focus:!tw-text-hylo-one-600'
                        linkLabel={`${this.translations.labelSwitchToPage} ${this.menu.menu.easy_speach.name}, ${checkActivePath(this.menu.menu.easy_speach.href, true) ? this.translations.labelCurrentPage+',' : ''}`}
                        noOutline
                      >
                        <span>{this.menu.menu.easy_speach.name}</span>
                        <hylo-icon icon="reading" height={16} />
                      </hylo-router-link>}
                      <hylo-button-contrast
                        hyloButtonClass='hylo-plain'
                        buttonClass='hylo-accessibility-list-child !tw-text-hylo-black hylo-hover:!tw-text-hylo-one-600 hylo-focus:!tw-text-hylo-one-600'
                      >
                        <span>{this.translations.textContrast}</span>
                        <hylo-icon icon="contrast" height={16} />
                      </hylo-button-contrast>
                      <hylo-button-font 
                        steps={2}
                        hyloButtonClass='hylo-plain'
                        buttonClass='hylo-accessibility-list-child !tw-text-hylo-black hylo-hover:!tw-text-hylo-one-600 hylo-focus:!tw-text-hylo-one-600'
                      > 
                        {this.translations.textFontSize}
                        <span class="hylo-icon tw-font-semibold" aria-hidden="true"><small>A</small><span class="tw-large">A</span></span>
                      </hylo-button-font>
                      {!!this.menu.menu.dgs_video && 
                      <hylo-router-link
                        href={this.menu.menu.dgs_video.href}
                        class="hylo-button hylo-plain"
                        linkClass='hylo-accessibility-list-child !tw-text-hylo-black hylo-hover:!tw-text-hylo-one-600 hylo-focus:!tw-text-hylo-one-600'
                        linkLabel={`${this.translations.labelSwitchToPage} ${this.menu.menu.dgs_video.name}, ${checkActivePath(this.menu.menu.dgs_video.href, true) ? this.translations.labelCurrentPage+',' : ''}`}
                        noOutline
                      >
                        <span>{this.menu.menu.dgs_video.name}</span>
                        <hylo-icon icon="dgs" height={16} />
                      </hylo-router-link>}
                    </div>}
                  </div>
                </hylo-page-width>
              </div>

              <div class="tw-relative tw-z-10 tw-mt-5">
                <hylo-page-width>
                  <div class="tw-flex tw-justify-end tw-gap-x-9">
                    {!this.menu?.menu?.user && <hylo-router-link
                      href={this.menu?.menu?.login.href}
                      class="hylo-button hylo-standard !tw-hidden md:!tw-inline-flex tw-pointer-events-auto tw-select-none"
                      linkClass='hylo-accessibility-list-child !tw-bg-hylo-one-700 hylo-hover:!tw-bg-hylo-black hylo-focus:!tw-bg-hylo-black hylo-dark:!tw-text-black'
                      linkLabel={`${this.translations.labelSwitchToPage} ${this.menu?.menu?.login.name}, ${checkActivePath(this.menu?.menu?.login.href, true) ? this.translations.labelCurrentPage+',' : ''}`}
                      noOutline
                    >{this.menu?.menu?.login.name}</hylo-router-link>}
                    {!!this.menu?.menu?.user && <div 
                      ref={el => this.user_menu = el}
                      class={`tw-hidden md:tw-inline-flex tw-relative`}
                    >
                      <hylo-accessibility-button
                        ref={el => this.user_button = el}
                        class="hylo-button hylo-standard tw-inline-flex tw-pointer-events-auto !tw-bg-hylo-one-700 hylo-hover:!tw-bg-hylo-black hylo-dark:!tw-text-black" 
                        toggle={this.user_open ? 'opened' : 'closed'}
                        inactive 
                        preventFocus
                        onHyloAccessibilityButtonClicked={this.onUserMenu}
                        aria-hidden="false"
                      >{this.menu?.menu?.user.name}</hylo-accessibility-button>
                      <div class={`kn-header-layer-user dont-open-menu tw-flex tw-max-h-0 hylo-open-direct:tw-max-h-300 tw-overflow-hidden hylo-open-direct:tw-overflow-visible tw-flex-col tw-w-max tw-absolute tw-right-0 tw--bottom-2 tw-translate-y-full tw-bg-hylo-one-200 tw-rounded tw-pointer-events-auto ${this.user_open ? 'hylo-open' : ''}`}>
                        {Object.keys(this.menu?.menu.user.children).map(key => {

                          const item = this.menu?.menu?.user?.children[key];

                          return (
                            <hylo-router-link
                              class="tw-text-hylo-gray-600 hylo-hover:tw-text-hylo-black hylo-focus:tw-text-hylo-black"
                              linkClass='hylo-accessibility-list-child tw-w-full !tw-py-2 !tw-pl-3 !tw-pr-6 !tw-no-underline tw-border-hylo-one-300 tw-border-b last-child:tw-border-b-0'
                              contentClass='tw-gap-x-3 tw-items-center'
                              href={item.url}
                              linkLabel={`${this.translations.labelSwitchToPage} Dashboard, ${key}, ${checkActivePath(item.url, true) ? this.translations.labelCurrentPage+',' : ''}`}
                              no-outline
                            ><hylo-icon icon={item.icon} height="16" width="21"/><span>{key}</span></hylo-router-link>
                          )
                        })}
                      </div>
                    </div>}
                    <hylo-accessibility-button 
                      ref={el => this.burger = el}
                      class="hylo-button hylo-standard tw-items-center !tw-min-w-15 md:!tw-min-w-12 !tw-px-0 tw-pointer-events-auto !tw-bg-hylo-one-700 hylo-hover:!tw-bg-hylo-black hylo-dark:!tw-text-black" 
                      toggle={this.menu?.open ? 'opened' : 'closed'}
                      inactive 
                      preventFocus
                      onHyloAccessibilityButtonClicked={this.toggleMenu}
                      aria-hidden="false"
                    >
                      <hylo-glyph-burger 
                        class={`tw-w-7 tw-h-[11px] ${this.menu?.open ? 'hylo-active' : ''}`}
                        size="3px" 
                        rounded 
                        tabIndex={null}
                        hideMiddle
                      />
                    </hylo-accessibility-button>
                  </div>
                </hylo-page-width>
              </div>

              <div class="kn-header-layer tw-w-screen tw-h-screen tw-absolute tw-top-0 tw-left-0 tw-z-0 tw-bg-hylo-bg-body tw-translate-x-full hylo-open:tw-translate-x-0 tw-transition-transform tw-pointer-events-auto">
                <hylo-page-width class="tw-h-100%-h-screen-fix">
                  <div class="tw-pt-40 lg:tw-pt-45 tw-h-full">
                    <div class="tw-flex tw-flex-col tw-h-full tw-pb-8 tw-gap-y-6 md:tw-gap-y-10 tw-justify-between tw-overflow-y-auto">
                      <div class="tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap lg:tw-flex-nowrap md:tw-gap-y-10 tw-gap-x-20 lg:tw-gap-x-10 tw-justify-start lg:tw-justify-between tw-max-w-275">
                        {getMenuPageBySlug('menu-main', this.menu?.menu?.header)?.children?.map((item: any[], index: number) => {

                          return this.getMenuMain(item, index);
                        })}
                      </div>
                      {this.getMenuSub(getMenuPageBySlug('menu-sub', this.menu?.menu?.header)?.children)}
                    </div>
                  </div>
                </hylo-page-width>
              </div>

              <div class="kn-header-layer tw-hidden hylo-open:tw-flex lg:hylo-open:tw-hidden tw-absolute tw-top-5 md:tw-top-18 tw-right-24 sm:tw-right-31 tw-z-10 tw-pointer-events-auto">
                <form
                  class="tw-flex tw-max-w-72 tw-h-12 lg:tw-h-10 tw-gap-x-1 tw-bg-hylo-one-300 tw-rounded-hylo-default"
                  onSubmit={this.onSearch}
                >
                  <input 
                    ref={el => this.search_2 = el}
                    class="tw-max-w-60 tw-h-full tw-pl-3 tw-py-1.5 tw-bg-transparent tw-outline-0"
                    aria-label={this.translations.labelSearchTerm+', '}
                  />
                  <hylo-button
                    buttonClass='tw-flex !tw-px-3 tw-justify-center tw-items-center !tw-border-0'
                    type="submit"
                    buttonLabel={this.translations.labelStartSearch+', '}
                  ><hylo-icon icon="search" width={24} /></hylo-button>
                </form>
              </div>

            </hylo-accessibility-list>
          </nav>
        </hylo-page-menu>
      </header>
    )
  }
}